import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import FeedForecastComponent from '@app/components/apps/FeedForecast/FeedForecastComponent';

const AddFeedForecast = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Feed Forecasts');

  const routes = [
    { path: '/feed-forecasts', breadcrumbName: 'Feed Forecasts' },
    { path: '/add-feed-forecast', breadcrumbName: 'Add Feed Forecasts' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FeedForecastComponent
          editable={true}
          pageTitle={'Add Feed Forecasts'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default AddFeedForecast;
